import { Post } from '../types';
import { toPlainText } from '../lib/helpers';

export const mapCatData = (categories: any) => {
  return categories?.map((cat: any) => cat.title) || [];
};

export const mapPostData = ({
  id,
  title,
  description,
  _rawExcerpt,
  _rawBody,
  slug,
  mainImage,
  categories,
  authors,
  factCheckers,
  bodyUpdatedAt,
  publishedAt
}: Post) => ({
  id: id || '',
  description: description || '',
  title: title || '',
  excerpt: toPlainText(_rawExcerpt) || '',
  body: _rawBody || {},
  href: slug?.current || '#',
  img: mainImage?.asset?.gatsbyImageData || null,
  imgAlt: mainImage?.alt || undefined,
  categories: mapCatData(categories) || [],
  authors: authors || [],
  factCheckers: factCheckers || [],
  bodyUpdatedAt: new Date(bodyUpdatedAt) || undefined,
  publishedAt: new Date(publishedAt) || undefined
});
